import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'get'

export default class OspreyAccountsGetById extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425a5'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getById(accountId, params) {
        this.params = params
        this.path = `/${resource}/${accountId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-get-by-id.js